import React from "react"
import PropTypes from "prop-types"

import Product from "./Product"

const ProductRow = ({ sameHeight, products }) => (
  <>
    {products.map(product => (
      <Product
        key={product.productName}
        name={product.productName}
        imageFluid={product.productImage.fluid}
        sameHeight={sameHeight}
        numCols={5 - products.length}
      />
    ))}
  </>
)

ProductRow.propTypes = {
  sameHeight: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
}

export default ProductRow
